var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-success",staticStyle:{"position":"fixed","right":"25px","top":"130px"}},[_c('font-awesome-icon',{staticStyle:{"font-size":"18px","cursor":"pointer"},attrs:{"icon":"save"},on:{"click":_vm.saveData}})],1),_c('div',{ref:"xspreadsheet",attrs:{"id":"xapp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }